import { Component, OnInit } from '@angular/core';
import { setLoggedInUserData } from '@app-helpers/functions';
import { AuthService } from '@app-services/auth-service/auth.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { states } from '@subscription-constants/subscriptionconstant';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { JsonPipe } from '@angular/common';
import { FestivalPaymentComponent } from '../festival-payment/festival-payment.component';
import { MatDialog } from '@angular/material/dialog';
import { id } from 'date-fns/locale';
import { BoardsService } from '@app-services/boarrds/boards.service';

@Component({
  selector: 'app-diagnostic-test',
  templateUrl: './diagnostic-test.component.html',
  styleUrls: ['./diagnostic-test.component.css']
})
export class DiagnosticTestComponent implements OnInit {
  disabledGetOtpBtn: boolean;
  loginData:any = { dialCode: '+91', phone: '',"firstName":'',"lastName":'',whatsappConsent:true ,otp:'',email:'',pincode:'',state:''};
  diagnosticUtility:any = {
    selecteddate:'',
    existingUser : false,
    mode:'login',
    counter:60,
    otpValid:true,
    slectedGrade:'8th',
    slectedexam:'CBSE',
    states:states,
    selectedValidity:{},
    selectedPackage:{},
    ruleid:'',
    fromPage:'diagonistic',
    timeslots:[],
    displayFormat:[],
    timeSlotSelection:{}
  }
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,

    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  grades: any = [
    {
      name: '8th',
      display: '8'
    }, {
      name: '9th',
      display: '9'
    }, {
      name: '10th',
      display: '10'
    },
    {
      name: '11th',
      display: '11'
    }, {
      name: '12th',
      display: '12'
    }
  ]
  public grade_examCombination = {
    '8th': ['CBSE'],
    '9th': ['CBSE'],
    '10th': ['CBSE'],
    '11th': ['CBSE'],
    '12th': ['NEET', 'JEE']

  }

  public examFullName = {
    'JEE': 'JEEMAIN',
    'CBSE': 'CBSE',
    'NEET': 'NEET'
  }
  gradeList = []
  examsList:any =[]
  constructor(public signUpService : SignupService,
    public userService:  UserService,
    private authService: AuthService,
    private ScheduleService:ScheduleService,
    private SubscriptionService: SubscriptionService,
    public spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private gradesService: BoardsService,
    ) { }
 public UserForm :any  ={

 }
  ngOnInit(): void {
    localStorage.setItem('tenantFromUrl','iltsc')
    localStorage.setItem('SelectedTab','subscribedPackages')
    this.gradesService.fetchGradesList().subscribe((resp:any)=>{
     this.gradeList =   resp;
     this.grades =  resp.map((v:any)=>{
      v.display = v.name?.replace(/[^0-9]/g, '')
        return v;
      }).filter(v=>v.display >7 && v.display < 13)

    })
    this.gradesService.fetchTargetExamList().subscribe((resp)=>{
      console.log('resp: ', resp);
       ['JEE Main','NEET','CBSE'].forEach((n)=>{
        this.examsList.push(resp.find(v=>v.name == n))
       })
       console.log(this.examsList);

    })
  }
  otpLogin() {
    this.disabledGetOtpBtn = true;
    let body = {
      dialCode: '+91',
      number: Number(this.loginData.phone)
    }
    this.signUpService.verifyPhoneNumber(body).subscribe((data:any) => {
       this.diagnosticUtility.existingUser = data?.existingUser; 
        this.genarateOTP();
      },(err)=>{

      })
     
  }
  genarateOTP() {
    let body :any= {"isdCode":"+91","phone":this.loginData.phone,"whatsappConsent":this.loginData.whatsappConsent}
    if(!this.diagnosticUtility.existingUser){
      body = {...body,"firstName":this.loginData.firstName,"lastName":this.loginData.lastName}
    }
    this.signUpService.generateOtp(body, '+91').subscribe((res) => {
      this.diagnosticUtility.mode = 'otp'
      if (res) {
         this.diagnosticUtility.resendOtpBtn = true;
        this.startCountdown(60)
      }
    })
  }

  startCountdown(seconds: any) {
    this.diagnosticUtility.counter = seconds;
    const interval = setInterval(() => {
       this.diagnosticUtility.counter--;
      if ( this.diagnosticUtility.counter < 10) {
        if ( this.diagnosticUtility.counter == 0) {
          
           this.diagnosticUtility.resendOtpBtn = false;
          clearInterval(interval);
          document.getElementById('resend-otp')?.focus()
        }
         this.diagnosticUtility.counter = '0' +  this.diagnosticUtility.counter
      }
    }, 1000); //for accurate reading, adjust this value to 980-996
  }
  
  onOtpChange(event: any) {
  
    // this.ngOtpInputRef.setValue(event);//yourvalue can be any string or number eg. 1234 or '1234'
    if (event.length === 4) {
      this.loginData.otp =event;
      // this.otpForm.get('otp')?.setValue(event);
       this.diagnosticUtility.otpValid = false
    } else {
        this.diagnosticUtility.otpValid = true
    }
  }
  validateOtp(){
    let body = {
      countryCode:'+91',
      phone:this.loginData.phone,
      "otp": this.loginData.otp
    }
    this.signUpService.validateOtp(body).subscribe((resp)=>{
      
   if(resp?.accessToken){
    setLoggedInUserData(resp, this.userService, this.authService);
    this.diagnosticUtility.mode = 'grade'
   }   
    })
  }
  selectGrade(grade){
    this.diagnosticUtility.slectedGrade = grade;
  }
  selectExam(exam){
    this.diagnosticUtility.slectedexam = exam;
  }
  getTimeSlots(){
    let userdetails = JSON.parse(localStorage.getItem('user_details_from_server')) 
   let exam = this.examsList.find(v=>v.name.indexOf(this.diagnosticUtility.slectedexam) !=-1 );
   let grade  = this.gradeList.find(v=>v.name == this.diagnosticUtility.slectedGrade);
   userdetails.exams = [exam]
   userdetails.grade = grade;
  this.spinner.show();

    this.userService.updateUserDetails(userdetails).subscribe((user)=>{
      setLoggedInUserData(user, this.userService, this.authService);
      let body = {
        "examtype": 'Infinity Learn Admission Test',
        "coursetype":  this.examFullName[this.diagnosticUtility.slectedexam],
        "grade":this.diagnosticUtility.slectedGrade,
        "phone": this.loginData.phone,
        "showRegistration": false
      }
      this.ScheduleService.getSlots(body).subscribe((resp)=>{
        this.diagnosticUtility.mode = 'buy';
        this.diagnosticUtility.timeslots = resp;
        this.diagnosticUtility.displayFormat =[];
        this.diagnosticUtility.selecteddate ={};
        this.diagnosticUtility.timeSlotSelection ={}
        this.dateAndSlots()
        this.spinner.hide();
    })  
    })

       
  }
  dateAndSlots(){
    this.diagnosticUtility.timeslots.forEach((v)=>{
        v.date =  moment(v?.span,"YYYY-MM-DD HH:mm A").format('DD-MMM-YYYY'),
        v.time = moment(v?.span,"YYYY-MM-DD HH:mm A").format('HH:mm:A')
    
    })
    
    var timedate = this.diagnosticUtility.timeslots.map(v=>v.date).filter((v,i,s)=>{
      return s.findIndex(inv=>inv == v) == i
    }) 
    timedate.forEach((v)=>{
      this.diagnosticUtility.displayFormat.push({
        avaibleSlots:this.diagnosticUtility.timeslots.filter(inv=>inv.date == v),
        date:v,
      })
    })
    
  }
  dateChange(date:any){
    
    if( date?.target?.value){
      this.diagnosticUtility.selecteddate = this.diagnosticUtility.displayFormat.find(v=>v.date == date.target.value)
      this.diagnosticUtility.timeSlotSelection ={};      

    }else{
      this.diagnosticUtility.selecteddate ={};
      this.diagnosticUtility.timeSlotSelection ={};
    }
  }
  selectslotOption(slot){
    this.diagnosticUtility.timeSlotSelection = slot;
    this.diagnosticUtility.ruleid = slot?.['_id']
  }
  buyPackage(){ 
    var param = {
      examName:  this.examFullName[this.diagnosticUtility.slectedexam],
      producttype: 'Assessment',
      grade: this.diagnosticUtility.slectedGrade?.replace(/[^0-9]/g, ''),
    }  
    this.SubscriptionService.totalexamTypePackages(param, param?.grade).subscribe((result: any) => {
      result= result?.filter(ele=>ele?.productId == 1);
      this.diagnosticUtility.selectedPackage = result?.[0];
      this.diagnosticUtility.selectedValidity = result?.[0]?.packageSubscriptionList?.[0]
      this.checkCart(param);
    })
  }
  checkCart(param){
    let userDetais = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')):{}
    this.diagnosticUtility.userDetails = userDetais;
    let body={
      "addOn": false,
      "batchId": '',
      "courseId":'',
      "created_by": userDetais?.firstName+' '+userDetais?.lastName,
      "created_date": moment().utc(),
      "grade": param?.grade,
      "id": 0,
      "modified_by": userDetais?.firstName+' '+userDetais?.lastName,
      "modified_date": moment().utc(),
      "phoneNo":  userDetais?.phone,
      "priority": 1,
      "quantity": 1,
      "scoreId": null,
      "status": true,
      "subscriptionId": this.diagnosticUtility?.selectedBatch?.id
      ? this.diagnosticUtility?.selectedPackage?.packageSubscriptionDto?.id
      : this.diagnosticUtility?.selectedValidity?.id
      ? this.diagnosticUtility?.selectedValidity?.id: '',
      "userId": userDetais?.userId,
      "afterDiscountAmount": this.diagnosticUtility?.selectedValidity?.amount,
      "amountOrPercentage": this.diagnosticUtility?.selectedValidity?.displayDiscountPercentage || this.diagnosticUtility?.selectedPackage?.packageSubscriptionDto?.displayDiscountPercentage,
      "amount": Number(this.diagnosticUtility?.selectedValidity?.amount || this.diagnosticUtility?.selectedPackage?.packageSubscriptionDto?.amount),
      "code": null,
      "discountType": null,
    }
    let cartbody = {
      grade: param?.grade,
      userId: userDetais?.userId
    }
    this.SubscriptionService.getAllCartItems(cartbody).subscribe((response: any) => {
      
      if(response.length){
        // let checkSubscriptionExisted =  response?.find(v => v?.subscription?.packages?.id == this.diagnosticUtility.selectedPackage?.id );
        var cartItemPromisearray =[]
        // this.spinner.show();
        response.forEach((cartItem)=>{ 
          cartItemPromisearray.push(this.deleteCartItems(cartItem.id))
        })
        Promise.all(cartItemPromisearray).then((re)=>{
          console.log('delte');
          this.saveCart(body)
        })
        // if(checkSubscriptionExisted){
        //   this.SubscriptionService.updateCart(body).subscribe((response:any) => {
        //     localStorage.setItem('CartItemID', response?.id);
        //     let dialogRef = this.dialog.open(FestivalPaymentComponent,
        //       {
        //         height: '650px',
        //         width: '1000px',
        //         panelClass:'festival-offer-dialog',
        //         data: {paymentData: this.diagnosticUtility,},
        //       }
        //     );
        //     this.spinner.hide();
        //   }, err => {
        //     this.spinner.hide();
        //   })
        // }

      }else{
        this.saveCart(body)
      }

    })
  }
  saveCart(body){
  this.SubscriptionService.saveCart(body).subscribe((response:any)=>{
    this.spinner.show();
    localStorage.setItem('CartItemID', response?.id);
    let dialogRef = this.dialog.open(FestivalPaymentComponent,
      {
        height: '650px',
        width: '1000px',
        panelClass:'festival-offer-dialog',
        data: {paymentData: this.diagnosticUtility,},
      }
    );
    this.spinner.hide();
  })
  }
  deleteCartItems(id){
    return new Promise((res,rej)=>{
      this.SubscriptionService.deleteFromCart(id).subscribe((resp)=>{
        res(true)
      })
    })
  }
}
